import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { mfaVerify } from '../../../Controllers/AuthController';

function MfaVerify({
  username,
  session,
  setError,
  setIsAuthed,
  onLoginSuccess,
}) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await mfaVerify(username, session, code);

      if (result === true) {
        // Call authenticate to fetch session data before setting isAuthed
        if (onLoginSuccess) {
          await onLoginSuccess();
        }
        setIsAuthed(true);
        return;
      }

      setError('Failed to verify code. Please try again.');
    } catch (err) {
      setError(err.message || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    setCode(value);
  };

  return (
    <>
      <h4 className="card-title text-center mb-3">Two-Factor Authentication</h4>

      <p className="text-muted text-center mb-4">
        Enter the 6-digit code from your authenticator app
      </p>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control form-control-lg text-center"
            id="mfaCode"
            value={code}
            onChange={handleCodeChange}
            placeholder="000000"
            maxLength={6}
            pattern="[0-9]{6}"
            autoComplete="one-time-code"
            inputMode="numeric"
            required
            style={{ letterSpacing: '0.5em', fontFamily: 'monospace' }}
          />
        </div>
        <button
          type="submit"
          disabled={loading || code.length !== 6}
          className="btn btn-primary w-100"
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Verifying...
            </>
          ) : (
            'Verify'
          )}
        </button>
      </form>
    </>
  );
}

MfaVerify.propTypes = {
  username: PropTypes.string.isRequired,
  session: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  setIsAuthed: PropTypes.func.isRequired,
  onLoginSuccess: PropTypes.func.isRequired,
};

export default MfaVerify;
